if (!customElements.get('sw-profit-calculator')) {
  customElements.define('sw-profit-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const slider = this.querySelector('input[type="range"]');
      const perUnit = Number(this.dataset.unitProfit);
      const days = Number(this.dataset.businessDays);
      const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
      const update = () => {
        const daily = Number(slider.value);
        const units = daily * days;
        this.querySelector('[data-daily-sales]').textContent = daily;
        this.querySelector('[data-monthly-units]').textContent = units;
        this.querySelector('[data-monthly-profit]').textContent = currency.format(units * perUnit);
        this.querySelector('[data-annual-profit]').textContent = currency.format(units * perUnit * 12);
        slider.style.setProperty('--sw-range-fill', `${(daily - Number(slider.min)) / (Number(slider.max) - Number(slider.min)) * 100}%`);
      };
      slider.addEventListener('input', update);
      update();
    }
  });
}

if (!customElements.get('sw-founder-video')) {
  customElements.define('sw-founder-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button');
      const label = button.querySelector('.sw-video-play > span:last-child');
      const playLabel = label.textContent;
      label.setAttribute('aria-live', 'polite');
      const reset = (message) => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = message;
      };
      button.addEventListener('click', () => {
        if (!this.video) {
          const markup = this.querySelector('template').content.querySelector('video');
          const source = [...markup.querySelectorAll('source')].find(item => item.type === 'video/mp4');
          const rawSource = source?.getAttribute('src') || markup.getAttribute('src');
          if (!rawSource) { reset('Video unavailable'); return; }
          const url = new URL(rawSource, window.location.href);
          if (url.pathname.startsWith('/cdn/shop/videos/')) {
            url.hostname = 'cdn.shopify.com';
            url.pathname = url.pathname.replace('/cdn/shop/videos/', '/videos/');
            url.search = '';
          }
          const video = document.createElement('video');
          video.className = 'sw-founder-player';
          video.controls = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.preload = 'auto';
          video.poster = button.querySelector('img').src;
          video.setAttribute('aria-label', markup.getAttribute('aria-label') || button.getAttribute('aria-label'));
          video.setAttribute('tabindex', '0');
          video.src = url.href;
          this.append(video);
          this.video = video;
          video.addEventListener('playing', () => { button.remove(); });
          video.addEventListener('error', () => { reset('Couldn’t load video. Tap to retry'); });
        }
        const video = this.video;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = 'Loading video…';
        if (video.error) video.load();
        // Keep play() in the tap handler so mobile Safari retains user activation.
        video.play().catch(error => {
          if (!video.isConnected || error.name === 'AbortError') return;
          reset(error.name === 'NotAllowedError' ? playLabel : 'Couldn’t load video. Tap to retry');
        });
      });
    }
    disconnectedCallback() {
      if (!this.video) return;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
    }
  });
}

(() => {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('sw-papers-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: .2, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.sw-formulation-section').forEach(section => {
    section.classList.add('sw-paper-reveal-ready');
    observer.observe(section);
  });
})();
